import styled from 'styled-components'

export const Container = styled.div`
  padding: 30px 22px;

  border-bottom: 1px solid;
  border-bottom-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#909090')};

  .result {
    border-radius: 100px;
    border-width: 1px;
    border-style: solid;

    font-size: 14px;
    font-weight: 600;
    line-height: 130%;

    padding: 8px 12px;

    width: fit-content;

    margin-bottom: 18px;

    &[data-status='right'] {
      color: ${({ theme }) => (theme.isDark ? '#007500' : '#0B6D66')};
      border-color: ${({ theme }) => (theme.isDark ? '#007500' : '#0B6D66')};
    }

    &[data-status='wrong'] {
      color: ${({ theme }) => (theme.isDark ? '#EB6D60' : '#E74C3C')};
      border-color: ${({ theme }) => (theme.isDark ? '#EB6D60' : '#E74C3C')};
    }

    &[data-status='pending'] {
      color: ${({ theme }) => (theme.isDark ? '#BABABA' : '#808080')};
      border-color: ${({ theme }) => (theme.isDark ? '#BABABA' : '#808080')};
    }
  }

  .clickable-area {
    border: none;
    background: none;

    text-align: start;

    :hover {
      .short-text {
        color: rgb(${({ theme }) => theme.primary.base});
        text-decoration: underline;
      }
    }

    .short-text {
      font-size: 14px;
      font-weight: 500;
      line-height: 120%;

      margin-bottom: 18px;

      max-width: 496px;

      white-space: normal;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;

      color: rgb(${({ theme }) => theme.grayscale[100]});

      transition: color 0.3s ease;
    }
  }

  .badges {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    margin-bottom: 18px;

    p {
      padding: 8px;

      font-size: 12px;
      font-weight: 500;
      line-height: 130%;

      border-radius: 4px;

      color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#4A4A4A')};
      background-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#DDD')};
    }
  }

  .delete-mobile {
    display: flex;
    justify-content: center;

    font-size: 14px;
    font-weight: 600;
    line-height: 140%;

    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

    color: ${({ theme }) => `rgb(${theme.primary.base})`};

    background: none;

    width: 100%;

    padding: 12px 0;
  }

  .delete-desktop {
    display: none;
  }

  @media only screen and (min-width: 800px) {
    .group-1 {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;

      .badges {
        margin-bottom: 0;
      }

      .delete-mobile {
        display: none;
      }

      .delete-desktop {
        display: block;

        border-radius: 4px;

        color: rgb(${({ theme }) => theme.primary.base});
        border: 1px solid rgb(${({ theme }) => theme.primary.base});
        background: none;

        :hover {
          color: rgb(${({ theme }) => theme.background.high});

          background: rgb(${({ theme }) => theme.primary.base});
        }
      }
    }
  }
`
